import { SelectField, Section } from './types';

export const isSelectField = (formField: any): formField is SelectField => !!formField.options;

export const isSection = (formComponent: any): formComponent is Section => !!formComponent.fields;
